import { render, staticRenderFns } from "./SingularityMilestoneComponent.vue?vue&type=template&id=67ba0edb&scoped=true"
import script from "./SingularityMilestoneComponent.vue?vue&type=script&lang=js"
export * from "./SingularityMilestoneComponent.vue?vue&type=script&lang=js"
import style0 from "./SingularityMilestoneComponent.vue?vue&type=style&index=0&id=67ba0edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba0edb",
  null
  
)

export default component.exports